const VEHICLE_SITUATION = [
    { value: 'PaidOff', label: 'Quitado' },
    { value: 'Financed', label: 'Financiado' },
];

export default VEHICLE_SITUATION